//@ts-check
const CONSTS = require("./consts")
var texts = require("./texts")

export function getParametersOfDeployERC20Step({
  constructorABI,
  owner,
  supply,
}) {
  var parameters = []
  var findInitialSupply = false
  if (constructorABI) {
    constructorABI.inputs.forEach(input => {
      if (input.type == "address") {
        parameters.push(owner)
      } else if (input.type == "uint256") {
        findInitialSupply = true
        parameters.push(supply)
      } else if (input.type == "uint8") {
        // decimals
        parameters.push(18)
      } else if (input.type == "string") {
        // name or symbol
        parameters.push(texts.constructor_variable)
      } else if (input.type == "bytes32") {
        // name or symbol
        parameters.push("0x123")
      } else {
      }
    })
  }
  return { parameters, findInitialSupply }
}

/**
 * @param files {scr.file[]}}
 * @param mainFile {scr.mainFile}}
 * @param mainContract {scr.mainContract}
 * @param compilerVersion {scr.compilerVersion}
 * @param compilerVersion {scr.compilerVersion}
 * @param steps {scr.Step[]}
 *  @param abi {import("../backend/interfaces").ABIField[]}
 * */
export function makeStepsMatchABI(
  files,
  mainFile,
  mainContract,
  compilerVersion,
  steps,
  abi,
) {
  /** @type {import("../backend/interfaces").Step[]} */
  var newMultiSteps = []
  let encodedIndex = 1
  let owner
  for (let i = 0; i < steps.length; i++) {
    var thisStep = steps[i]
    var smartContractName = "The " + mainContract + " smart contract binary"
    if (thisStep.type == CONSTS.STEP_TYPES.DEPLOY_ERC20) {
      owner = thisStep.owner
      var smartContractAddress =
        "The " + mainContract + " smart contract deployed address"
      var constructorABI = abi.find(abiItem => abiItem.type == "constructor")
      let ans = getParametersOfDeployERC20Step({
        constructorABI,
        //@ts-ignore
        owner: thisStep.owner,
        //@ts-ignore
        supply: thisStep.supply,
      })
      newMultiSteps.push({
        type: CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT,
        files,
        mainContract,
        mainFile,
        compilerVersion,
        abi,
        alias: smartContractName,
        parameters: ans.parameters,
      })
      newMultiSteps.push({
        type: CONSTS.STEP_TYPES.MANUAL_TRANSACTION,
        //@ts-ignore
        from: thisStep.owner,
        to: "",
        data: { type: "choose", chosenValue: smartContractName },
        deployAlias: smartContractAddress,
        sender: "0x65432456543",
      })
      if (!ans.findInitialSupply) {
        for (let ABIFunctionname of ["_mint", "mint"]) {
          if (ABIfunctionExists(abi, ABIFunctionname)) {
            let TwoSteps = oneStep2TwoStep(
              {
                type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
                function_name: ABIFunctionname,
                sender: thisStep.owner,
                is_optional: true,
                parameters: [thisStep.owner, thisStep.supply],
              },
              "Encode the mint function",
            )
            newMultiSteps = [...newMultiSteps, ...TwoSteps] // combine arraies
          }
        }
      }
      for (let ABIFunctionname of ["unfreeze", "unpause"]) {
        if (ABIfunctionExists(abi, ABIFunctionname)) {
          if (
            abi.find(abiItem => abiItem.name == ABIFunctionname)?.inputs
              ?.length != 0
          )
            break
          let TwoSteps = oneStep2TwoStep(
            {
              type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
              function_name: ABIFunctionname,
              sender: thisStep.owner,
              is_optional: true,
              parameters: [],
            },
            "unfreeze",
          )
          newMultiSteps = [...newMultiSteps, ...TwoSteps] // combine arraies
        }
      }
    } else if (thisStep.type == CONSTS.STEP_TYPES.EXEC_FUNCTION) {
      let TwoSteps = oneStep2TwoStep(
        thisStep,
        "Encoded function #" + encodedIndex++,
        owner,
      )
      newMultiSteps = [...newMultiSteps, ...TwoSteps] // combine arraies
    }

    /**
     * @param  step {import("../backend/interfaces").ExecFunction}}
     * @param  funcName {string}
     * @returns {scr.Step[]}
     */
    function oneStep2TwoStep(step, funcName, owner = "") {
      return [
        {
          type: CONSTS.STEP_TYPES.ENCODE_TRANSACTION,
          SC_Alias: smartContractName,
          function_name: step.function_name,
          parameters: step.parameters,
          alias: funcName,
        },
        {
          type: CONSTS.STEP_TYPES.MANUAL_TRANSACTION,
          to: { type: "choose", chosenValue: smartContractAddress },
          data: { type: "choose", chosenValue: funcName },
          from: step.sender || owner,
        },
      ]
    }
  }
  newMultiSteps.map(x => (x.collapsed = true))
  console.log({ newMultiSteps })
  return newMultiSteps

  var index = 0
  if (steps.length == 0) return steps
  if (steps[0].type == CONSTS.STEP_TYPES.DEPLOY_ERC20) {
    index++
    /** @type {import("../backend/interfaces").DeployERC20Step} */
    // @ts-ignore
    var step = steps[0]

    /** @type {import("../backend/interfaces").DeployStep} */
    // @ts-ignore
    var newStep = { ...step }

    // unpause
    // unfreeze

    var parameters = abi.find(abiItem => abiItem.type == "constructor")
    newStep.type = CONSTS.STEP_TYPES.DEPLOY
    newStep.sender = step.owner
    var ans = getParametersOfDeployERC20Step({
      constructorABI: parameters,
      owner: step.owner,
      supply: step.supply,
    })
    //@ts-ignore
    newStep.parameters = ans.parameters
    newMultiSteps.push(newStep)
    if (!ans.findInitialSupply) {
      if (ABIfunctionExists(abi, "_mint")) {
        newMultiSteps.push({
          type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
          function_name: "_mint",
          sender: step.owner,
          is_optional: true,
          parameters: [step.owner, step.supply],
        })
      }
      if (ABIfunctionExists(abi, "mint")) {
        newMultiSteps.push({
          type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
          function_name: "mint",
          sender: step.owner,
          is_optional: true,
          parameters: [step.owner, step.supply],
        })
      }
    }
    if (ABIfunctionExists(abi, "unfreeze")) {
      newMultiSteps.push({
        type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
        function_name: "unfreeze",
        sender: step.owner,
        is_optional: true,
        parameters: [],
      })
    }
    if (ABIfunctionExists(abi, "unpause")) {
      newMultiSteps.push({
        type: CONSTS.STEP_TYPES.EXEC_FUNCTION,
        function_name: "unpause",
        sender: step.owner,
        is_optional: true,
        parameters: [],
      })
    }
  }
  for (; index < steps.length; index++) {
    newMultiSteps.push(steps[index])
  }
  newMultiSteps.map(x => (x.collapsed = true))
  return newMultiSteps
}

function ABIfunctionExists(abi, funcName) {
  return !!abi.find(abiItem => abiItem.name == funcName)
}
